import { html } from "lit";

export const Template = () => {
    return html`
        <div class="block block-marginal block-marginal-contact">
            <div class="marginal-headline">
                <span class="headline-small">Kontakt</span>
            </div>
            <div class="block-wrapper">
                <div class="block-content">
                    <div class="title-normal">Sales Power Tools</div>
                    <div class="text-medium u-color-gray-paragraph"></div>
                    <div class="text-medium u-color-gray-paragraph"></div>
                    <div class="block-marginal-contact-phoneNr">
                        <a href="tel:+41-58-257-61-44">
                            Telefon +41 58 257 61 44
                        </a>
                    </div>
                    <div class="block-marginal-contact-phoneNr">
                        Fax +41 58 257 64 01
                    </div>
                    <a
                        class="ux-text-link ux-text-link--green"
                        subject="title"
                        body="HTTP_REFERER"
                        href='mailto:powertools@ch.trumpf.com?subject=Anfrage über Website: "TruTool C 160"&amp;body=%0D%0ADiese Anfrage kam über die Seite https://srv01jira1/'
                    >
                        E-Mail
                        <ux-icon name="arrow-small-right"></ux-icon>
                    </a>
                    <br />
                </div>
            </div>
        </div>
        <div
            id="c24440"
            class="frame frame-default frame-type-trumpfcst_serviceslistmarginal frame-layout-0"
        >
            <header></header>
            <div
                class="block block-marginal block-marginal-serviceIcons ux-u-mt-s ux-u-mt-md-m ux-u-mb-xxxs ux-u-mb-md-xxs "
            >
                <div class="marginal-headline">
                    <span class="headline-small"> Services </span>
                </div>
                <div class="block block-marginal block-marginal-serviceIcons">
                    <div class="block-wrapper">
                        <div class="block-content u-clearfix">
                            <ux-iws-teaser-sidebar-icon>
                                <ux-icon name="globe" slot="icon"></ux-icon>
                                <span slot="title" class="ux-text-normal">
                                    Finanzierung
                                </span>
                                <a
                                    href="#"
                                    class="ux-text-link ux-text-link--green"
                                    slot="link"
                                >
                                    Discover more
                                    <ux-icon name="arrow-small-right"></ux-icon>
                                </a>
                            </ux-iws-teaser-sidebar-icon>
                            <ux-iws-teaser-sidebar-icon>
                                <ux-icon name="crane" slot="icon"></ux-icon>
                                <span slot="title" class="ux-text-normal">
                                    Schulungen
                                </span>
                                <a
                                    href="#"
                                    class="ux-text-link ux-text-link--green"
                                    slot="link"
                                >
                                    Discover more
                                    <ux-icon name="arrow-small-right"></ux-icon>
                                </a>
                            </ux-iws-teaser-sidebar-icon>
                            <ux-iws-teaser-sidebar-icon>
                                <ux-icon
                                    name="machine-circle-arrows"
                                    slot="icon"
                                ></ux-icon>
                                <span slot="title" class="ux-text-normal">
                                    Gebrauchtmaschinen
                                </span>
                                <a
                                    href="#"
                                    class="ux-text-link ux-text-link--green"
                                    slot="link"
                                >
                                    Discover more
                                    <ux-icon name="arrow-small-right"></ux-icon>
                                </a>
                            </ux-iws-teaser-sidebar-icon>
                            <ux-iws-teaser-sidebar-icon>
                                <ux-icon
                                    name="document-checkmark"
                                    slot="icon"
                                ></ux-icon>
                                <span slot="title" class="ux-text-normal">
                                    Servicevereinbarungen
                                </span>
                                <a
                                    href="#"
                                    class="ux-text-link ux-text-link--green"
                                    slot="link"
                                >
                                    Discover more
                                    <ux-icon name="arrow-small-right"></ux-icon>
                                </a>
                            </ux-iws-teaser-sidebar-icon>
                            <ux-iws-teaser-sidebar-icon>
                                <ux-icon
                                    name="avatar-technical-service"
                                    slot="icon"
                                ></ux-icon>
                                <span slot="title" class="ux-text-normal">
                                    Technischer Kundendienst
                                </span>
                                <a
                                    href="#"
                                    class="ux-text-link ux-text-link--green"
                                    slot="link"
                                >
                                    Discover more
                                    <ux-icon name="arrow-small-right"></ux-icon>
                                </a>
                            </ux-iws-teaser-sidebar-icon>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;
};
